import React from 'react'
import { AllCardsType } from '../../../data/all-cards'

export const ShowCards = ({ selectedCards, mazo }: { selectedCards: AllCardsType[]; mazo: string }) => {
    return (
        <div className="flex flex-col items-center justify-center w-full h-full mini:px-2 md:px-5">
            <div className="grid gap-3 mini:grid-cols-5 xl:grid-cols-7">
                {selectedCards.map((card: AllCardsType, index: number) => (
                    <div className="flex flex-col gap-2">
                        <img
                            src={require('../../../assets/' + mazo + card.url + '/' + card.image)}
                            className={`mini:w-[17vw] xl:w-[5.38vw] mini:h-auto xl:h-[19vh] rounded-md ${
                                card.position === 'invertida' ? 'rotate-180' : ''
                            }`}
                            alt=""
                        />
                        <div className="mini:w-[17vw] xl:w-[5.38vw] bg-violetLight text-sm text-center rounded-md">
                            {card.name}
                        </div>
                    </div>
                ))}
            </div>
        </div>
    )
}
